<script lang="ts">
    import AnimatingMoreArrow from "../../widgets/AnimatingMoreArrow.svelte"
    import CookieSet from "../../widgets/CookieSet.svelte"
    import MedialibFile from "../../widgets/MedialibFile.svelte"
    import MedialibImage from "../../widgets/MedialibImage.svelte"
    import VideoJs from "./VideoTextRow/VideoJs.svelte"
    import { _ } from "svelte-i18n"
    let { block }: { block: VideoBlock } = $props()
    let play = $state(false)
    let hoverPlay = $state(false)
    const cnt = block.content
    const extractVideoId = (link: string) => {
        const regex = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]{11})/
        const match = link.match(regex)
        return match ? match[1] : null
    }

    let videoId = extractVideoId(cnt.video_url)
    let embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&showinfo=0` : null
</script>

<section class="video">
    <button
        class="thumbnail-preview"
        onclick={() => {
            if (videoId) {
                if (!play) play = true
            } else {
                play = !play
            }
        }}
        class:play
    >
        <MedialibImage id={cnt.video_cover_img} alt="Video Preview" />
        <div class="content">
            <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
                <path
                    d="M61.227 28.0589C62.6679 28.8252 63.8731 29.969 64.7136 31.3679C65.5541 32.7668 65.9981 34.368 65.9981 35.9999C65.9981 37.6319 65.5541 39.2331 64.7136 40.632C63.8731 42.0309 62.6679 43.1747 61.227 43.9409L22.791 64.8419C16.602 68.2109 9 63.8309 9 56.9039V15.0989C9 8.16895 16.602 3.79195 22.791 7.15495L61.227 28.0589Z"
                    stroke="white"
                    stroke-width="1.5"
                ></path>
            </svg>
            {#if cnt.videotitle}
                <h2>{cnt.videotitle}</h2>
            {/if}
            {#if cnt.video_caption}
                <p>
                    {cnt.video_caption}
                </p>
            {/if}

            <!-- svelte-ignore a11y_no_static_element_interactions -->
            <div
                onmouseenter={() => (hoverPlay = true)}
                onmouseleave={() => (hoverPlay = false)}
                class="to-profile"
                class:active={hoverPlay}
            >
                <span>{$_("general.play")}</span>
                <AnimatingMoreArrow active={hoverPlay} color="bright" />
            </div>
        </div>
    </button>

    <div class="video-wrapper" class:yt={!!videoId && play}>
        {#if !cnt.use_external}
            <MedialibFile id={cnt.video_file[0]} let:src>
                <VideoJs {src} muted={false} controlPlayFromOutside={true} {play} enableAutoplayOnVisible={false} />
            </MedialibFile>
        {:else}
            <CookieSet
                force={!videoId}
                cookieName={"youtube"}
                textPosition={"unten"}
                background={"rgba(44, 44, 44, 0.4)"}
            >
                {#snippet contentSnippet()}
                    <VideoJs
                        src={videoId ? embedUrl : cnt.video_url}
                        muted={false}
                        controlPlayFromOutside={true}
                        {play}
                        enableAutoplayOnVisible={false}
                    />
                {/snippet}
            </CookieSet>
        {/if}
    </div>
</section>

<style lang="less" global>
    @import "../../../css/variables.less";
    section.video {
        width: 100%;
        position: relative;
        display: block;
        button {
            position: absolute;
            z-index: 10;
            cursor: pointer;
            width: 100%;
            display: block;
            border: none;
            padding: 0;
            margin: 0;
            overflow: hidden;
            border-radius: 4px;
            top: 0;
            bottom: 0;
            &.play {
                opacity: 0;
                pointer-events: none;
                z-index: 1;
                .content {
                    pointer-events: none;
                }
            }
            &::before {
                position: absolute;
                z-index: 100;
                inset: 0;
                width: 100%;
                content: "";
                border-radius: inherit;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.55) 100%);
                pointer-events: none;
            }
            picture,
            img {
                width: 100%;
                height: auto;
                object-fit: cover;
                display: block;
            }
            .content {
                position: absolute;
                z-index: 100;
                bottom: 0px;
                left: 0px;
                inset: 0;
                padding: 2.4rem;
                & > svg {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                gap: 0.6rem;
                h2 {
                    width: 100%;
                    color: var(--bright-100);
                    text-align: left;
                }
                p {
                    width: 100%;
                    color: var(--bright-100);
                    font-size: 1rem;
                    font-weight: 400;
                    text-align: left;
                    margin-bottom: 0.6rem;
                }
                & > .to-profile {
                    &:hover {
                        span {
                            padding-left: 0.3rem;
                        }
                    }
                    &.to-profile {
                        color: var(--bright-100);
                        span {
                            font-size: 0.7rem;
                            transition: padding-left 0.3s ease-in-out;
                        }
                        display: flex;
                        align-items: center;
                        width: 100%;
                        img {
                            height: 1.2rem;
                        }

                        display: flex;
                        justify-content: flex-start;
                        width: 100%;
                        gap: 0.6rem;
                        &.active span {
                            color: var(--brand-100) !important;
                        }
                    }
                }
            }
        }
        .video-wrapper {
            width: 100%;
            display: block;
            position: relative;
            z-index: 5;
            &.yt {
                z-index: 20;
            }
        }
    }
</style>
